module.exports = __webpack_public_path__ + "static/media/gallery26.198ef000.jpeg";